// extracted by mini-css-extract-plugin
export default {"wrapper":"AlertWrapper_wrapper__1w8oa","wrapper__copy":"AlertWrapper_wrapper__copy__Rl2bP"};